import {Injectable} from "@angular/core";
import {ReplaySubject, Subject, Subscription} from "rxjs";
import {AppEvent} from "./AppEvent";
import {AppEventName} from "./AppEventName";

@Injectable({
  providedIn: 'root',
})
export class AppEventBus {

  private eventBus$: Subject<AppEvent> = new ReplaySubject<AppEvent>(100, 3000);

  dispatch(event: AppEvent): void {
    console.debug(`Dispatching app event: ${JSON.stringify(event)}`);
    this.eventBus$.next(event);
  }

  subscribe(eventName: AppEventName, handler: (event: AppEvent) => void): Subscription {
    return this.eventBus$.subscribe((event) => {
      if(event.eventName === eventName) {
        console.debug(`Handling app event: ${JSON.stringify(event)}`);

        try {
          handler(event);
        }
        catch(error) {
          console.error(`Failed to handle app event: ${JSON.stringify(event)}`, error);
        }
      }
    });
  }
}
